export enum CandidatePay {
	Paye = 1,
	Umbrella = 2,
	LtdCompany = 3,
	NotApplicable = 4,
}

export enum CandidatePaymentIntervals {
	Monthly = "Monthly",
	Weekly = "Weekly",
	WeeklyPayInArrears = "Weekly Pay in Arrears",
	Biweekly = "Bi-Weekly",
}
